import { render, staticRenderFns } from "./QuestionChoices.vue?vue&type=template&id=da6a7184&scoped=true&"
import script from "./QuestionChoices.vue?vue&type=script&lang=js&"
export * from "./QuestionChoices.vue?vue&type=script&lang=js&"
import style0 from "./QuestionChoices.vue?vue&type=style&index=0&id=da6a7184&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6a7184",
  null
  
)

export default component.exports